
type FormatUserFullNameParamsType = {
  firstName: string;
  lastName: string;
  preferredFirstName?: string;
  fallback?: string;
};

type FormatUserFullNameFunctionType = (params: FormatUserFullNameParamsType) => string;

export const formatUserFullName: FormatUserFullNameFunctionType = ({ firstName, lastName, preferredFirstName, fallback = '' }) => {
  if (preferredFirstName || firstName || lastName) {
    return `${preferredFirstName || firstName} ${lastName}`;
  }

  return fallback;
};

export type DisplayName = {
  first: string;
  last: string;
};

type GetUserFullName = (firstName: string, lastName: string, preferredName?: string) => DisplayName;

export const getUserFullName: GetUserFullName = (firstName, lastName, preferredName) => ({
  first: `${preferredName || firstName}`,
  last: lastName,
});

export const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName[0].toUpperCase();

  const last = lastName[0].toUpperCase();

  return `${first}${last}`;
};
